export type EditorRouteData = {
  pathname: string
  search?: string
  state?: unknown
}

export const pushRouteFromEditor = (editor: { pushRoute?: (route: EditorRouteData) => void; requestProps?: { history?: { push: (route: EditorRouteData) => void } } }, routeData: EditorRouteData): void => {
  if (editor?.pushRoute) {
    editor.pushRoute(routeData)
    return
  }
  editor?.requestProps?.history?.push(routeData)
}
